/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  fetchUserCourses ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/userCourse/getAllUsersCourses/')
        .then((response) => {
          console.log(response.data);
          commit('SET_USER_COURSES', response.data.data)
          // commit('SET_USER_COURSES_COUNT', response.data.count)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCourses ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/userCourse/getAllCourses/')
        .then((response) => {
          commit('SET_COURSES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/userCourse/getAllUsers/')
        .then((response) => {
          commit('SET_ALLUSERS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateUserCourses ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/userCourse/updateUserCourse/${payload.id}`, payload)
        .then((response) => {
          console.log("dsasd");
         dispatch('fetchUserCourses')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addUserCourses ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/userCourse/addUserCourse/`, payload)
        .then((response) => {
         dispatch('fetchUserCourses')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
}
